import { Link } from 'react-router-dom'
import { SubmitBtnProvider } from 'contexts/SubmitBtnContext'
import ForgotPasswordForm from './ForgotPasswordForm'
import FrontendRoutes from 'assets/js/classes/FrontendRoutes'

export default function ForgotPassword() {  
  return (
    <>
      <h4 className="mb-0 d-flex flex-column">
        Forgot your password?
        <span>Enter your email address to receive instructions to reset your password.</span>
      </h4>

      <div className="divider row"></div>

      <SubmitBtnProvider>
        <ForgotPasswordForm />
      </SubmitBtnProvider>

      <div className="mt-2 d-flex flex-row-reverse">
        <Link to={FrontendRoutes.ACCOUNT_LOGIN}>Go Back</Link>
      </div>
    </>
  );
};